import { VIEWPORT_EVENTS } from '../../constants/Events';
import { ConsoleLogger } from './loggers/ConsoleLogger';
import { DomLogger } from './loggers/DomLogger';

const DEFAULT_LOGGERS = [
  { key: 'console', logger: ConsoleLogger },
  { key: 'dom', logger: DomLogger },
];

class LoggerPlugin extends Phaser.Plugins.BasePlugin {
  constructor(pluginManager) {
    super(pluginManager);
    this.loggersByName = new Map();
    this.domScene = false;
  }

  init(config) {}

  onGameReady() {
    this.game.viewportController.events.on(VIEWPORT_EVENTS.UPDATED, this._updatePosition, this);
  }

  addDefaultLoggers() {
    for (let i = 0; i < DEFAULT_LOGGERS.length; i++) {
      this.addLogger(DEFAULT_LOGGERS[i].key, DEFAULT_LOGGERS[i].logger);
    }
  }

  addDomLogger(key, config = {}) {
    this.addLogger(key, DomLogger, config);
  }

  addConsoleLogger(key, config = {}) {
    const log = new Logger(this.game, null, key, ConsoleLogger, config);
    this.loggersByName.set(key, log);
  }

  addLogger(key, logger, config) {
    const log = new Logger(this.game, this.getScene(logger), key, logger, config);
    this.loggersByName.set(key, log);
  }

  removeLogger(key) {
    this.loggersByName.get(key)?.destroy();
    this.loggersByName.delete(key);
  }

  set domScene(value) {
    this._domScene = value;
  }

  get domScene() {
    return this._domScene;
  }

  getScene(component) {
    if (!this.domScene && component === DomLogger) {
      this.domScene = this.game.scene.add('DomLogger', {}, true);
    }
    return this.domScene;
  }

  log(...args) {
    this.loggersByName.forEach((logger) => {
      logger.log(...args);
    });
  }

  getLoggerVisibility(key) {
    return this.loggersByName.get(key)?.getLoggerVisibility() ?? false;
  }

  setLoggerVisibility(key, value) {
    this.loggersByName.get(key)?.setLoggerVisibility(value);
  }

  _updatePosition() {
    this.loggersByName.forEach((logger) => {
      logger.updatePosition();
    });
  }
}

class Logger {
  constructor(game, scene, id, logger, config) {
    this._id = id;
    this._logger = new logger(game, scene, config, id);
  }

  get id() {
    return this._id;
  }

  get component() {
    return this._logger;
  }

  log(...args) {
    this._logger.log(...args);
  }

  getLoggerVisibility(key) {
    return this._logger.getLoggerVisibility();
  }

  setLoggerVisibility(value) {
    this._logger.setLoggerVisibility(value);
  }

  destroy() {
    this._logger.destroy();
    this._logger = null;
  }

  updatePosition() {
    this._logger.updatePosition();
  }
}

export { LoggerPlugin };
